import { useMemo } from 'react';
import { Box, InputLabel } from '@mui/material';

import { RadioFormField } from 'types';
import { defaultLanguage } from 'context';
import { useCourseContext } from 'context';

import { RadioField } from '../fields';

export const FormRadioField = ({
  id,
  label,
  options,
  translations,
}: RadioFormField) => {
  const { language } = useCourseContext();

  const translation = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return {
        label,
        options: options?.options
          ? options?.options.map((value) => ({ value, label: value }))
          : [],
      };
    }

    const translation = translations[language];
    const langOptions = translation.options || options?.options;
    return {
      label: label ? translation?.label || label : label,
      options: langOptions
        ? langOptions.map((value, index) => ({
            label: value,
            value: options?.options?.[index] || value,
          }))
        : [],
    };
  }, [label, options?.options, language, translations]);

  return (
    <Box>
      {translation.label && (
        <InputLabel className="mb-2">{translation.label}</InputLabel>
      )}
      <RadioField
        name={id}
        padding="0px"
        options={translation.options}
        radioGroupClassName="flex flex-col gap-2"
      />
    </Box>
  );
};
